<template>
  <div class="gmxkz_tx">
    <div>
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="searchForm"
            label-position="center"
            label-width="90px"
          >
            <el-form-item label="许可证编号:">
              <el-input
                v-model="searchForm.xkzbh"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="化学品名称">
              <!-- <el-select v-model="searchForm.hxp" placeholder="">
                <el-option label="item.label" value="item.value"> </el-option>
              </el-select> -->
              <el-input
                v-model="searchForm.hxpmc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="核发日期:" style="">
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="开始时间"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="结束时间"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>

            <el-button
              v-preventReClick
              class="sousuoButton"
              icon="el-icon-search"
              size="small"
              round
              type="primary"
              @click="getlist()"
            >搜索</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 25px;
          padding-bottom: 51px;
        "
      >
        <div class="tablemes">
          <el-button
            v-preventReClick
            type="primary"
            style="margin-bottom: 25px"
            @click="getlist()"
          >刷新</el-button>
          <el-table
            ref="cktable"
            :data="tableData"
            border
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              :show-overflow-tooltip="true"
              prop="xkzbh"
              align="center"
              label="许可证编号"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              prop="hxpmc"
              align="center"
              label="化学品名称"
            />
            <!-- prop="hxpsl" @y2022/1/9 17:10 -->
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="化学品数量"
            >
              <template slot-scope="scope">
                {{ scope.row.hxpsl }}{{ scope.row.hxpsldwmc }}
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="dwmc"
              align="center"
              label="销售单位"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              prop="yxqks,yxqjs"
              align="center"
              label="有效期限"
            >
              <template slot-scope="scope">
                {{ scope.row.yxqks }}至{{ scope.row.yxqjs }}
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="hfrq"
              align="center"
              label="核发日期"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              prop="tsxx"
              width="200px"
              align="center"
              label="提示消息"
            />
            <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <span>
                  <el-button
                    v-preventReClick
                    type="primary"
                    size="mini"
                    @click="operation(scope.row)"
                  >操作</el-button>
                   <el-button
                     v-preventReClick
                     type="danger"
                     size="mini"
                     @click="remove(scope.row.id)"
                   >删除</el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="pagesize"
            class="el-page"
            @current-change="currentpage"
            @size-change="sizechange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 获取接口地址

import { zjwsyGmzlist, removeWsyById } from '@/assets/js/notification'
import {deleteResource} from "@/assets/js/resource";

export default {
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.endTime) {
            return time.getTime() > new Date(this.searchForm.endTime).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pupopShow: false,
      searchForm: {
        xkzbh: '',
        hxpmc: '',
        beginTime: '',
        endTime: ''
      },
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10 // 每页的数据条数
    }
  },
  mounted() {
    // 获取列表
    this.getlist()
  },
  methods: {
    // 获取列表
    getlist() {
      zjwsyGmzlist({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 翻页
    currentpage(e) {
      this.currentPage = e
      // 获取列表
      this.getlist()
    },
    // 修改每页条数
    sizechange(e) {
      this.pagesize = e
      // 获取列表
      this.getlist()
    },
    operation(row) {
      // 链接到购买入库-新增
      this.$router.push({ name: 'Gmrk', params: { xkzBh: row.ywid }})
    },
    remove(id) {
      this.$confirm('删除后该购买证不会再产生此类提醒，确认删除吗?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeWsyById(id).then((res) => {
          if (res.status === 200 && res.data.code === '000000') {
            this.$message.success('删除成功!')
            this.getlist()
          }
        })
      })
    }
  }
}
</script>
<style scoped lang='less'>
.el-table--border {
  z-index: 0;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.gmxkz_tx {
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
